import DownloadCard from './DownloadCard'

export default DownloadCard
